import { EnvironmentProviders, importProvidersFrom, Provider } from "@angular/core";
import { MAT_DATE_LOCALE } from "@angular/material/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";

import { I18nPaginatorIntl } from "services/mat-paginator-i18n.service";

import { i18nHttpLoaderFactory } from "./i18n-http-loader.factory";

const DEFAULT_LANGUAGE = "en";

export const provideI18n = (): (Provider | EnvironmentProviders)[] => {
  return [
    {
      provide: MAT_DATE_LOCALE,
      useValue: localStorage.getItem("lang") || DEFAULT_LANGUAGE,
    },
    // Update ngx-translate and use provideTranslateService/provideTranslateHttpLoader utils
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: i18nHttpLoaderFactory,
        },
        isolate: false,
        extend: true,
        defaultLanguage: DEFAULT_LANGUAGE, // Default language will be set by LanguageFacade in AppComponent
      })
    ),
    {
      provide: MatPaginatorIntl,
      useClass: I18nPaginatorIntl,
    },
  ];
};
